import { useMemo } from 'react';
import useMediaQuery from 'common/hooks/useMediaQuery';
import useStyles from '../useStyles';

import type { IProps } from '../index';

interface ClassesProps extends Pick<IProps, 'variant'> {
  hasValue: boolean;
}

const useClasses = ({ variant, hasValue }: ClassesProps) => {
  const { isMobile } = useMediaQuery();
  const classes = useStyles({ isMobile, variant, hasValue });

  const multiSelectClasses = useMemo(() => ({
    formControl: {
      root: classes.formControlRoot
    },
    select: {
      root: classes.selectRoot,
      icon: classes.selectIcon
    },
    menuItem: {
      root: classes.menuItemRoot,
      text: { root: classes.menuItemText },
      checkboxContainer: classes.checkboxContainer
    },
    menuHeader: {
      search: { root: classes.menuHeaderSearch },
      searchIcon: { root: classes.searchIcon }
    }
  }), [classes]);

  return { classes, multiSelectClasses };
};

export default useClasses;
